module.exports = __webpack_public_path__ + "img/SingingInTheRain.fe6084e4.svg";